const stepperData = [
  "内容入力",
  "対象施設一覧確認・異動状況登録",
  "入力内容確認",
  "機構へ提出",
];
export { stepperData };
